import {tokens} from '@commercial-helios/ui/theme'
import React from 'react'
import styled from 'styled-components'

import Image from '@helios/shared/components/image'
import {Text} from '@helios/shared/styles/typography'
import type ImageSource from '@helios/shared/types/image'
import mq from '@helios/shared/utils/media-query'

interface TemplateProps {
    imgSrc: ImageSource
    title: string
    subtitle: string
}

const Template = ({imgSrc, title, subtitle}: TemplateProps) => (
    <ProofPoint>
        <Image image={imgSrc} />

        <div>
            <Text variant="label-base-medium">{title}</Text>
            <Text variant="label-base">{subtitle}</Text>
        </div>
    </ProofPoint>
)

interface Props {
    proofPoints: {
        title: string
        subtitle: string
        icon: ImageSource
    }[]
}

export const ProofPointBadges = ({proofPoints}: Props) => (
    <HeroProofPoints>
        {proofPoints.map(({icon, title, subtitle}, key) => (
            <Template key={key} imgSrc={icon} title={title} subtitle={subtitle} />
        ))}
    </HeroProofPoints>
)

export const ProofPoint = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: ${tokens.spacing8};
    justify-items: center;
    text-align: center;

    ${mq.min('xs')} {
        justify-content: start;
        grid-template-columns: auto auto;
        text-align: left;
    }

    img {
        width: 40px;
    }
`

const HeroProofPoints = styled.div`
    display: flex;
    gap: ${tokens.spacing32};
`
